export default "__VITE_ASSET__DmzWzVOL__"